import { render, staticRenderFns } from "./DropdownSelector.vue?vue&type=template&id=02be2033&scoped=true"
import script from "./DropdownSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DropdownSelector.vue?vue&type=style&index=0&id=02be2033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be2033",
  null
  
)

export default component.exports